/**
 * Vendor observability realm (TASK-144) — a SEPARATE identity realm for the
 * innow8apps vendor/dev team, fully isolated from staff + guest auth. Observe-only.
 */
export enum VendorRole {
  /** Read-only observer: console + traces/logs/feed/diagnostics. */
  OBSERVER = 'observer',
  /** Observer + manages the vendor team (invite/disable/roles). */
  ADMIN = 'admin',
}

/** Vendor access-token payload. `aud` fences the realm — staff/guest tokens can't pass. */
export interface VendorJwtPayload {
  sub: string; // vendor_users.id
  email: string;
  role: VendorRole;
  aud: 'vendor-console';
}

export interface VendorUserDTO {
  id: string;
  email: string;
  fullName: string | null;
  role: VendorRole;
  isActive: boolean;
  lastLoginAt: string | null;
  createdAt: string;
}

export interface VendorAuthResponse {
  accessToken: string;
  refreshToken: string;
  user: VendorUserDTO;
}
